import { F as _, b as E, a as d, c as I, g as O } from "./chunks/index-5de47637.mjs";
import { e as S, c as m, d as u, a as F, b as h, T as w, i as g, h as P, s as U, f as V, j as f, g as k } from "./chunks/toast-5242d1d0.mjs";
import c from "vue";
const t = (o, e, a = () => {
}) => {
  const s = document.createElement("div");
  (document.querySelector(e == null ? void 0 : e.container) || document.body).appendChild(s);
  const r = new c({ el: s, name: "VueDialogHelper", render: (T) => T(o, { props: e, on: { close: (...i) => {
    a(i), r.$destroy();
  } } }) });
};
export {
  _ as FilePicker,
  E as FilePickerBuilder,
  d as FilePickerType,
  I as FilePickerVue,
  S as TOAST_ARIA_LIVE_ASSERTIVE,
  m as TOAST_ARIA_LIVE_OFF,
  u as TOAST_ARIA_LIVE_POLITE,
  F as TOAST_DEFAULT_TIMEOUT,
  h as TOAST_PERMANENT_TIMEOUT,
  w as TOAST_UNDO_TIMEOUT,
  O as getFilePickerBuilder,
  g as showError,
  P as showInfo,
  U as showMessage,
  V as showSuccess,
  f as showUndo,
  k as showWarning,
  t as spawnDialog
};
